// extracted by mini-css-extract-plugin
export default {"Quiz":"Quiz_Quiz__IBFu-","QuizWrapper":"Quiz_QuizWrapper__i9Eyf"};